function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  fontFamily: "material",
  fontSize: 20,
  fontWeight: "normal"
}, React.createElement("g", {
  id: "Checkout---4",
  transform: "translate(-798.000000, -665.000000)",
  fill: "#FFFFFF"
}, React.createElement("g", {
  id: "Login",
  transform: "translate(796.000000, 421.000000)"
}, React.createElement("g", {
  id: "Remember-me",
  transform: "translate(0.000000, 240.000000)"
}, React.createElement("g", {
  id: "checkbix"
}, React.createElement("text", {
  id: "\\uE886"
}, React.createElement("tspan", {
  x: 0,
  y: 17
}, "\uE886")))))));

var SvgTickmark = function SvgTickmark(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "16px",
    height: "12px",
    viewBox: "0 0 16 12",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgTickmark, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/tickmark.3e2402a2.svg";
export { ForwardRef as ReactComponent };